import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PeraturanData = {
  CLW_ISI_IDX: number;
  CLW_ISI_NOMOR: string;
  CLW_ISI_TAHUN: string;
  CLW_MENU_NAME: string;
  CLW_ISI_KETERANGAN: string;
  CLW_BERLAKU: number;
};

type InitialState = {
  dataPutusan: PeraturanData[];
  totalData: number;
};

const initialState: InitialState = {
  dataPutusan: [
    
    // Add more data items as needed
  ],
  totalData: 0, // Initialize totalData here
};

export const putusan = createSlice({
  name: 'putusan',
  initialState,
  reducers: {
    replaceAllPutusan: (state, action: PayloadAction<PeraturanData[]>) => {
      state.dataPutusan = action.payload; // Replace the entire array with the new array
    },
    updateTotalData: (state, action: PayloadAction<number>) => {
      state.totalData = action.payload; // Update the totalData value in the state
    },
  },
});

export const { replaceAllPutusan, updateTotalData } = putusan.actions;
export default putusan.reducer;
